import { render } from "./addstaff.vue?vue&type=template&id=dee6ecf2"
import script from "./addstaff.vue?vue&type=script&lang=js"
export * from "./addstaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__